import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBacktestApi } from '../../hooks/useBacktestApi';
import styles from './TraderDashboard.module.css';
import {aiCopilotService} from '../../services/aiCopilotService';

function BacktestDetails() {
  const { runId } = useParams();
  const { loading, error, getBacktestDetails } = useBacktestApi();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      if (runId) {
        try {
          const data = await getBacktestDetails(runId);
          setDetails(data);
        } catch (err) {
          console.error("Failed to load details", err);
        }
      }
    };
    fetchDetails();
  }, [runId, getBacktestDetails]);

  // Helper for safe number formatting
  const formatNum = (val, isPercent = false, decimals = 2) => {
    if (val === null || val === undefined || isNaN(val)) return 'N/A';
    const multiplier = isPercent ? 100 : 1;
    const suffix = isPercent ? '%' : '';
    return (val * multiplier).toFixed(decimals) + suffix;
  };

  if (loading) return <div className={styles.loading}>Loading backtest details...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!details) return <div className={styles.noHistory}>No backtest details found.</div>;

  return (
    <div className={styles.detailsContainer}>
      <h2>Backtest Run Details: {details.run_name}</h2>
      <p>Run ID: {details.id}</p>
      <p>Date: {details.created_at ? new Date(details.created_at).toLocaleDateString() : 'N/A'}</p>
      
      {/* Summary Metrics */}
      <div className={styles.metricsGrid}>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Total Return</p>
          <p className={styles.metricValue}>{formatNum(details.metrics?.total_return, true)}</p>
        </div>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Sharpe Ratio</p>
          <p className={styles.metricValue}>{formatNum(details.metrics?.sharpe_ratio)}</p>
        </div>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Max Drawdown</p>
          <p className={styles.metricValue}>{formatNum(details.metrics?.max_drawdown, true)}</p>
        </div>
      </div>

      {/* Trades Table */}
      <h3>All Trades ({details.trades_count || 0})</h3>
      <table className={styles.historyTable}>
        <thead>
          <tr>
            <th>Ticker</th>
            <th>Buy Date</th>
            <th>Buy Price</th>
            <th>Sell Date</th>
            <th>Sell Price</th>
            <th>P&L</th>
          </tr>
        </thead>
        <tbody>
          {(details.trades || []).map((trade, index) => (
            <tr key={index}>
              <td>{trade.ticker}</td>
              <td>{trade.buy_date || 'N/A'}</td>
              <td>{formatNum(trade.buy_price)}</td>
              <td>{trade.sell_date || 'N/A'}</td>
              <td>{formatNum(trade.sell_price)}</td>
              <td style={{ color: (trade.pnl || 0) >= 0 ? 'green' : 'red' }}>
                {formatNum(trade.pnl)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BacktestDetails;